// ═══════════════════════════════════════════════════════════════════════════
// LA LANGUE D'UN GUIDE DE BLOG, DÉDUITE DE SON ADRESSE
// ───────────────────────────────────────────────────────────────────────────
// ⚠️ POURQUOI CE FICHIER EXISTE, mesuré le 02/09/2026 sur la page servie.
// `app/blog/layout.js` est UN SEUL gabarit pour les 82 guides des DEUX langues
// (68 FR, 14 NL). Un layout Next ne reçoit ni le slug ni les paramètres de la
// page enfant : il n'a donc aucun moyen, côté serveur, de savoir dans quelle
// langue il s'affiche. Résultat en production : un lecteur néerlandophone
// arrivait sur `/blog/ouderschapsverlof-belgie`, lisait un article en
// néerlandais, et tombait sur un en-tête et un pied de page ENTIÈREMENT en
// français dès qu'il faisait défiler — « Guides récents », « Tous les guides »,
// et une liste de 16 guides français. C'est le fondateur qui l'a vu.
//
// 🔑 LA MÉCANIQUE N'EST PAS NEUVE : `NewsletterInline` la pratiquait déjà
// depuis le 08/08 — et c'est exactement pour ça que son bloc était le SEUL du
// pied de page à s'afficher en néerlandais. On l'extrait ici pour que les deux
// (bientôt quatre) endroits ne puissent plus diverger, plutôt que de la
// recopier une troisième fois.
//
// ⚠️ La langue vient du REGISTRE, jamais d'une prop : la passer à la main
// voudrait dire toucher 82 fichiers, et le 83ᵉ serait oublié.
import { BLOG_ARTICLES } from '@/app/lib/blog-registry';

/** `/blog/<slug>` (avec ou sans barre finale) → le slug, sinon null. */
export function slugDuGuide(pathname) {
  const m = /^\/blog\/([^/]+)\/?$/.exec(String(pathname || ''));
  return m ? m[1] : null;
}

/**
 * La langue du guide servi à cette adresse.
 *
 * ⚠️ REND 'fr' PAR DÉFAUT, ET C'EST VOULU : hors d'un guide (l'index /blog),
 * sur un slug inconnu, ou pendant le premier rendu serveur d'une route
 * inattendue, le français est le repli sûr — il correspond aux 68 guides sur
 * 82. Un défaut 'nl' servirait du néerlandais à 83 % des lecteurs.
 */
export function langueDuGuide(pathname) {
  const slug = slugDuGuide(pathname);
  if (!slug) return 'fr';
  return BLOG_ARTICLES.find((a) => a.slug === slug)?.lang === 'nl' ? 'nl' : 'fr';
}

/**
 * Les guides les plus récents DE CETTE LANGUE.
 *
 * ⚠️ C'est le cœur du défaut corrigé : `articlesRecents()` trie les 82 guides
 * toutes langues confondues, donc les 16 plus récents étaient français et le
 * pied de page néerlandais listait 16 titres français. Un lecteur qui clique
 * atterrit dans une langue qu'il n'a pas demandée — pire qu'un lien absent.
 * ⚠️ Le NL n'a que 14 guides : la liste est plus COURTE, elle ne se complète
 * pas avec du français pour faire nombre (même règle que `liens-pied-page`).
 */
export function guidesRecentsDe(lang, limite) {
  const l = lang === 'nl' ? 'nl' : 'fr';
  const tri = BLOG_ARTICLES
    .filter((a) => (a.lang || 'fr') === l)
    .sort((a, b) => b.published.localeCompare(a.published));
  return limite ? tri.slice(0, limite) : tri;
}
